import { render, staticRenderFns } from "./VenueSingle.vue?vue&type=template&id=656329c2&"
import script from "./VenueSingle.vue?vue&type=script&lang=js&"
export * from "./VenueSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports